
























import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";

// Mixins
import RequestPromises from "@/mixins/requestPromises";

// Enums/Data
import { DataModules } from "@/store/modules/data";

// Types
import { IClient } from "@/models/clients";
import Context from "@/mixins/context";

@Component({
  computed: {
    ...mapState({
      unifiableCountScope(state, getters) {
        return getters[`data/${DataModules.INVOICES}/unifiableCountScope`](
          this.clientId
        );
      },
      unifiableCount(state, getters) {
        return getters[`data/${DataModules.INVOICES}/unifiableCount`](
          this.clientId
        );
      }
    })
  }
})
export default class ClientInvoiceConsolidationMessage extends Mixins(
  RequestPromises,
  Context
) {
  // Map state

  public unifiableCountScope!: string;
  public unifiableCount!: number;

  // Props

  @Prop({ required: true })
  public clientId!: IClient["id"];

  // Data

  public isLoading = true;

  // Life-cycle methods

  public created() {
    this.loadData();
  }

  public beforeDestroy() {
    this.$store.dispatch("data/binList", {
      storeModule: DataModules.INVOICES,
      scope: this.unifiableCountScope,
      vm: this
    });
  }

  // Methods

  public async loadData() {
    try {
      await this.$store.dispatch(
        `data/${DataModules.INVOICES}/getConsolidatableTotal`,
        {
          clientId: this.clientId,
          scope: this.unifiableCountScope,
          ignoreStored: true,
          vm: this
        }
      );
    } catch (error) {
      // Silently catch error
    } finally {
      this.isLoading = false;
    }
  }

  public openConsolidateModal() {
    this.$store.dispatch(
      `data/${DataModules.INVOICES}/openConsolidateInvoicesModal`,
      {
        props: { clientId: this.clientId }
      }
    );
  }

  // Computed

  public get isVisible() {
    return !this.isLoading && this.unifiableCount > 1;
  }
}
